import { PageRequest } from '@/core/request/PageRequest';

export enum BilletsStatus {
  saved = 'SALVO',
  failed = 'FALHA',
  emited = 'EMITIDO',
  rejected = 'REJEITADO',
  registred = 'REGISTRADO',
  liquidated = 'LIQUIDADO',
  downloaded = 'BAIXADO',
  pending_retry = 'PENDENTE_RETENTATIVA',
}

export const BilletsStatusColor = {
  [BilletsStatus.saved]: 'yellow',
  [BilletsStatus.failed]: 'red',
  [BilletsStatus.emited]: 'blue',
  [BilletsStatus.rejected]: 'red',
  [BilletsStatus.registred]: 'blue',
  [BilletsStatus.liquidated]: 'green',
  [BilletsStatus.downloaded]: 'green',
  [BilletsStatus.pending_retry]: 'yellow',
};

export const BilletsStatusType = {
  [BilletsStatus.saved]: 'Salvo',
  [BilletsStatus.failed]: 'Falha',
  [BilletsStatus.emited]: 'Emitido',
  [BilletsStatus.rejected]: 'Rejeitado',
  [BilletsStatus.registred]: 'Registrado',
  [BilletsStatus.liquidated]: 'Liquidado',
  [BilletsStatus.downloaded]: 'Baixado',
  [BilletsStatus.pending_retry]: 'Pendente Retentativa',
};

export interface ConfigBulletRequest {
  companyId: number;
  bankAccountId: number;
  agreementNumber: string;
  agreementDescription: string;
  agreementWallet: string;
  agreementWalletCode: string;
  agreementSpecies: string;
  agreementCNABPattern: string;
  agreementRestartDaily?: boolean;
  agreementRemittanceNumber: string;
  agreementRemittanceDensity: string;
  agreementInstantRegister?: boolean;
  agreementStation: string;
  agreementBankOurNumber?: boolean;
  agreementContractNumber: string;
  agreementLayoutFileVersion: string;
  agreementWebServiceType: string;
  agreementWsConsult?: boolean;
}

export interface ConfigBulletDetail {
  id: number;
  bankAccountId: number;
  agreementNumber: string;
  agreementDescription: string;
  agreementWallet: string;
  agreementWalletCode: string;
  agreementSpecies: string;
  agreementCNABPattern: string;
  agreementRestartDaily: boolean;
  agreementRemittanceNumber: string;
  agreementRemittanceDensity: string;
  agreementInstantRegister: string;
  agreementStation: string;
  agreementBankOurNumber: string;
  agreementContractNumber: string;
  agreementLayoutFileVersion: string;
  useWebService: boolean;
  automaticRegistration: boolean;
}

export interface GenerateBulletRequest {
  installmentReceivableId: number;
  bankAccountId: number;
  accountReceivableId: number;
}

export interface GenerateBulletResponse {
  statusIdInstallmentReceivableId: number;
  billIntegrationId: string;
  billStatus: string;
  billNumber: string;
  billProtocol: string;
}
export interface ListBillets {
  id: number;
  installmentReceivableId: number;
  accountReceivableId: number;
  codeIdentifier: string;
  companyId: string;
  companyName: string;
  bankAccountId: number;
  bankAccountName: string;
  bankAccountCode: string;
  changeTicketProtocol?: string;
  integrationId: string;
  status: BilletsStatus;
  documentNumber: string;
  ourNumber: string;
  printProtocol: string;
  remittanceEmitted: boolean;
  createdAt: string;
  dueDate: string;
  billRegisterDate: string;
  billLiquidationDate: string;
  billDoneDate: string;
  billRejectDate: string;
  billIncludedNotaryOfficeDate: string;
  digitableLine: string;
  barCode: string;
  titleValue: number;
  protocol: string;
  motive?: string;
  debtor: string;
  writeOffProtocol?: string;
}

export interface ListBilletsQuery extends PageRequest {
  search?: string;
  companyId?: number;
  workOrderNumber?: string;
}

export interface GenerateRemittanceRequest {
  companyId: number;
  installmentReceivableBillIds: number[];
}
export interface GenerateRemittanceAllRequest {
  companyId: number;
}
//Delete
export interface DeleteBankSlipRequest {
  companyId: number;
  installmentReceivableBillsIds: number[];
}
export interface ReturnFileBankSlipRequest {
  file: File;
  companyId: number;
}
export interface ReturnFileBankSlipResponse {
  message: string;
  protocol: string;
}

export interface RemittanceReturnProtocolRequest {
  companyId: number;
  protocol: string;
}
export interface RemittanceReturnProtocolResponse {
  situation: string;
  message: string;
  processed: number;
  titles: Titles[];
  unreconciledTitles: UnreconciledTitles[];
}

export interface WriteOffBankSlipRequest {
  companyId?: number;
  installmentReceivableBillsIds: number[];
}

export interface WriteOffBankSlipResponse {
  message: string;
  protocol: string;
}

export interface Titles {
  integrationId: string;
}
export interface UnreconciledTitles {
  movementCode: string;
  occurrenceCodes: string[];
  occurrences: string[];
  paymentAdditionalValue: number;
  paymentAmountChargeFee: number;
  paymentAmountOtherCredits: number;
  paymentAmountPaid: number;
  paymentCreditValue: number;
  paymentDate: string;
  paymentDateCredit: string;
  paymentMade: true;
  titleDocumentNumber: string;
  titleDueDate: string;
  titleOurNumber: string;
  titleOurOriginalNumber: string;
}

export interface GenerateRemittanceByWriteOffRequest {
  companyId: number;
  writeOffProtocol: string;
}

export interface IndividualTicketRequest {
  integrationId: string;
  titleValue: number;
  titleDueDate: string;
  titleDiscountValue: number;
  titleRebateValue: number;
  titleCodeProtest: number;
  titleProtestTerm: string;
}

export interface BankSlipRequestPdfResponse {
  situation: string;
  protocol: string;
}
